<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m12 l12 xl12">
				<input id="nome" name="nome" type="text" class="validate" v-model='item.nome' maxlength="150" required>
				<label for="nome">Nome</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m16 l6 xl6">
				<input id="tamanho" name="tamanho" type="number" class="validate" v-model='item.tamanho' min='100' max='5000' step='10' required>
				<label for="tamanho">Num. Caracteres</label>
			</div>
			<div class="input-field col s12 m12 l6 xl6">
				<select name="responsavel" v-model="item.responsavel" required class="browser-default select_sec">
					<option value="" disabled selected>Responsavel pelo preenchimento</option>
					<option v-for="responsavel in responsaveis">{{responsavel}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m16 l6 xl6">
				<input id="nota_min" name="nota_min" type="number" class="validate" v-model='item.nota_min' min='0.0' max='9.9' step='0.1' required>
				<label for="nota_min">Nota mínima</label>
			</div>
			<div class="input-field col s12 m16 l6 xl6">
				<input id="nota_max" name="nota_max" type="number" class="validate" v-model='item.nota_max' min='0.0' max='99.9' step='0.1' required>
				<label for="nota_max">Nota máxima</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l6 xl6">
				<select name="nota_var" v-model="item.nota_var" required class="browser-default select_sec">
					<option value="" disabled selected>Variação da nota</option>
					<option v-for="nota in notas">{{nota}}</option>
				</select>
			</div>
		</div>
		
		<div class="row">	
			<div class="input-field col s6 m6 l3 xl3">
				<button type="submit" class="btn"><i class="material-icons left">save</i>Salvar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
      name: "VueAvalRelItemForm",
      props: [
        'aval_item',
		'var_nota_aval',
		'var_responsavel'
      ],
      data () {
        return {
          item: JSON.parse(this.aval_item),
		  notas: JSON.parse(this.var_nota_aval),
		  responsaveis: JSON.parse(this.var_responsavel),
        }
      },
    }
</script>
